import { encodeMarker } from "@/data/map-markers";
import { gmapApi } from "vue2-google-maps";

export default {
	name: "KTrucksMapIconBase",

	computed: {
		google: gmapApi,

		iconAnchor() {
			return new this.google.maps.Point( this.marker.size / 2, this.marker.size / 2 );
		},

		iconSize() {
			return new this.google.maps.Size( this.marker.size, this.marker.size );
		},

		iconContent() {
			if ( !this.marker.url ) {
				return encodeMarker( this.marker ).content;
			}
		},

		markerIcon() {
			if ( this.iconContent ) {
				return {
					anchor: this.iconAnchor,
					url: this.iconContent,
					scaledSize: this.iconSize,
					size: this.iconSize
				};
			}

			return this.marker;
		}
	}
};
